import { useDisplayOptionContext } from "@/hooks/useDisplayOptionContext";
import { useDispatch } from "react-redux";
import { useFacility } from "@/hooks/useFacility";
import { translateWithMultipleSources } from "@/lib/translate";
import { FunnelType, Step } from "@/types/enums";
import { emitUnitEvent } from "@/utils/units/unitEvents";
import { initializeJourney } from "@/features/journey/journeySlice";
import { UnitGroup } from "@/types";
import { getSteps } from "@/hooks/useSteps";

export const useReservationAction = (
    unitGroup: UnitGroup,
    selectedPromo: number,
) => {
    const dispatch = useDispatch();
    const { reservationApp, language, buttonLayout } =
        useDisplayOptionContext();
    const unitId = unitGroup.representative_unit.id;
    const facilityId = unitGroup.representative_unit.facility_id;
    const { facility } = useFacility(facilityId);

    if (!unitId) {
        return {
            openReservationFunnel: () => null,
            label: "Reserve",
        };
    }

    const redirectToExternalReservation = (unitId: number) => {
        if (reservationApp?.externalUrl && facility) {
            window.location.href = translateWithMultipleSources(
                reservationApp.externalUrl,
                {
                    unitGroup,
                    facility,
                    promo: { id: selectedPromo },
                },
                Number(unitId),
                Number(selectedPromo),
            );
        } else {
            console.error(
                "External reservation URL or facility information is missing.",
            );
        }
    };

    const openSamePageReservationFunnel = (unitId: number) => {
        const subGroupCount = unitGroup.sub_groups?.length ?? 0;
        const steps = getSteps(subGroupCount, buttonLayout);

        emitUnitEvent(unitId, facilityId, selectedPromo, "reservation");
        dispatch(
            initializeJourney({
                unitId,
                unitGroup,
                selectedPromo,
                stepList: steps,
                step: Step.FUNNEL,
                funnelType: FunnelType.RESERVE,
            }),
        );
    };

    const openReservationFunnel = (selectedUnitId?: number) => {
        if (
            reservationApp?.location === "external" &&
            reservationApp.externalUrl
        ) {
            sessionStorage.setItem("facilityUrl", window.location.href);
            redirectToExternalReservation(selectedUnitId ?? unitId);
        } else {
            openSamePageReservationFunnel(selectedUnitId ?? unitId);
        }
    };

    const label = language?.action?.reserveButton || "Reserve";

    return { openReservationFunnel, label };
};
